<script setup lang="ts">
const { $twMerge } = useNuxtApp();

type Props = {
  text?: string; // for plain text
  html?: string; // for raw HTML
  appendClass?: string;
};

const props = withDefaults(defineProps<Props>(), {});
</script>

<template>
  <span
    :class="
      $twMerge(
        'block font-semibold text-transparent bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-3.57%,_var(--text-gradient-2)_80.72%)] py-4',
        props.appendClass
      )
    "
  >
    <!-- Prefer HTML if provided -->
    <span v-if="props.html" v-html="props.html"></span>
    <template v-else>
      <slot>
        {{ props.text || "Gradient Text" }}
      </slot>
    </template>
  </span>
</template>
